import axios from "../helpers/axios";
import {HashDetailDto} from "../models/dtos/hashDetail.dto";

export default class WheelService {

  async getHash(hash: string): Promise<HashDetailDto> {
    try {
      const response = await axios.get<HashDetailDto>(
        `${process.env.REACT_APP_BASE_URL}/tickets?hash=${hash}`,
      );
      return response.data;
    } catch (error) {
      throw error;
    }
  }

  async consume(hash: string): Promise<void> {
    try {
      const response = await axios.patch<void>(
        `${process.env.REACT_APP_BASE_URL}/tickets/consume`,
        {hash},
      );
      return response.data;
    } catch (error) {
      throw error;
    }
  }
}
